import(/* webpackMode: "eager" */ "/vercel/path0/apps/marketing/src/app/_components/footer/footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/marketing/src/app/_components/navbar/navbar-mobile.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/marketing/src/app/_components/navbar/navbar.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/marketing/src/app/_components/navbar/navbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
